module.exports = __webpack_public_path__ + "img/coupon-mockup.24c2b288.png";